export default __webpack_public_path__ + "static/frame1-b80d853b06d6f17d582b42d002b2f540.png";